export const HYPERLINK_VERSION = '0.1.6';

// Log version on import
console.log(`📦 @onchainfi/hyperlink v${HYPERLINK_VERSION} loaded`);

